import { getOrgJoinList, joinOrg } from '@/pages/system/user/service';
import { Form, message, Modal, Select } from 'antd';
import { debounce } from 'lodash';
import React, { useState } from 'react';
import styles from './globalCom.less';

interface ApplyProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
}

const Apply: React.FC<ApplyProps> = (props) => {
  const { visible, setVisible } = props;
  const [form] = Form.useForm();
  const [orgList, setOrgList] = useState([]);

  const modalOk = () => {
    form.submit();
  };

  const onFinish = (val: any) => {
    joinOrg(val.name).then((res) => {
      if (res.code === '00000') {
        message.success(res.msg);
        setVisible(false);
        setOrgList([]);
        form.resetFields();
      } else {
        // message.warning(res.msg);
      }
    });
  };

  const modalCancel = () => {
    setVisible(false);
    setOrgList([]);
    form.resetFields();
  };

  const onSearch = debounce((value: string) => {
    if (value.trim() === '') {
      setOrgList([]);
      return;
    } else {
      getOrgJoinList(value.trim()).then((res) => {
        if (res.code === '00000') {
          setOrgList(res.data);
        }
      });
    }
  }, 700);

  return (
    <>
      <Modal
        className={styles.setModelForm}
        title="申请加入已有机构"
        open={visible}
        // visible={visible}
        onOk={modalOk}
        onCancel={modalCancel}
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item label={''} name={'name'} rules={[{ required: true, message: '请选择机构' }]}>
            <Select
              showSearch
              allowClear
              onSearch={onSearch}
              placeholder="请输入需要加入的机构名称"
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option!.children as unknown as string).includes(input)
              }
              filterSort={(optionA, optionB) =>
                (optionA!.children as unknown as string)
                  .toLowerCase()
                  .localeCompare((optionB!.children as unknown as string).toLowerCase())
              }
            >
              {orgList.map((item: any) => {
                return (
                  <Select.Option value={item.value} key={item.value}>
                    {item.label}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Apply;
